module.exports = {
    expressPort: 8000,
    //siteUrl: "http://127.0.0.1:8000/api",
    siteUrl: (window.location.hostname === 'instructor.dutraforeducation.com.br') ?
        'https://api.dutraforeducation.com.br/api' :
        'https://api.dutraforeducation.com.br/api',
    // 'https://dutraeducation.codiflysoftware.com/api',
};
